module.exports = __webpack_public_path__ + "static/media/profile-picture-676w.063ade8a.jpg";